import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeOff } from 'lucide-react';
import { FcGoogle } from 'react-icons/fc';
import { FaApple } from 'react-icons/fa';
import loginBg from '../assets/1772.jpg';
import user1 from '../assets/man1.png';
import logo from '../assets/logo.png';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      navigate("/dashboard");
    }, 2000);
  };

  return (
    <div style={{ margin: 0, padding: 0, backgroundColor: 'white' }}>
      {/* ✅ CUSTOM STYLES */}
      <style>
        {`
          /* 🔵 Input fields */
          .custom-input {
            border-radius: 8px;
            padding: 12px 14px;
            border: 1px solid #ccc;
            transition: all 0.3s ease;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
          }
          .custom-input:focus {
            border-color: #007bff;
            box-shadow: 0 0 0 4px rgba(0, 123, 255, 0.15);
            outline: none;
          }

          /* 🔵 Login Button */
          .custom-btn {
            border-radius: 8px;
            padding: 12px;
            background: linear-gradient(135deg, #007bff, #0056d2);
            border: none;
            font-weight: bold;
            transition: transform 0.2s ease, box-shadow 0.3s ease;
          }
          .custom-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
          }
          .custom-btn:disabled {
            opacity: 0.7;
            cursor: not-allowed;
          }
        `}
      </style>

      <div className="container-fluid min-vh-100 p-0">
        <div className="row g-0" style={{ minHeight: '100vh' }}>

          {/* left */}
          <div
            className="col-12 col-md-6 d-none d-md-block position-relative"
            style={{
              backgroundImage: `url(${loginBg})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              minHeight: '100vh'
            }}
          >
            {/* Overlay */}
            <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

            {/* Testimonial Box */}
            <div className="position-absolute bottom-0 start-0 end-0 m-4 p-3 rounded shadow text-white"
              style={{ background: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(8px)' }}>
                <h3>Hotel Identity Verification System</h3>
              <p className="fs-4 fw-light">
                We can now confirm every guest’s identity in seconds. Safe, Secure, and Reliable.
              </p>
              <div className="d-flex align-items-center mt-3">
                <img src={user1} alt="User" className="rounded-circle me-2"
                  style={{ width: '40px', height: '40px', objectFit: 'cover' }} />
                <div>
                  <p className="mb-0 fw-bold">Chinedu M.</p>
                  <small>Abuja, Nigeria</small>
                </div>
              </div>
            </div>
          </div>

          {/* right*/}
          <div
            className="col-12 col-md-6 d-flex align-items-center justify-content-center p-4"
            style={{ backgroundColor: 'white' }}
          >
            <div className="w-100" style={{ maxWidth: '480px' }}>
              <a href="/" className="d-block mb-4">
                <img src={logo} alt="Hotel Verification System" height="50" />
              </a>

              <h2 className="fw-bold mb-2">Welcome Back✨</h2>
              <p className="text-muted mb-4">Access the staff dashboard to verify guests</p>

              {/* ✅ Login Form */}
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label small fw-bold">Email</label>
                  <input
                    type="email"
                    className="form-control custom-input"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-bold">Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="form-control custom-input"
                      placeholder="••••••••"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="btn w-100 mt-2 custom-btn text-white d-flex justify-content-center align-items-center"
                >
                  {loading ? (
                    <div className="spinner-border spinner-border-sm text-light" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Login"
                  )}
                </button>
              </form>

              {/* Divider */}
              <div className="d-flex align-items-center my-4">
                <div className="flex-grow-1 border-top"></div>
                <span className="mx-3 text-muted small">or</span>
                <div className="flex-grow-1 border-top"></div>
              </div>

              {/* 🔗 Social Buttons */}
              <div className="d-grid gap-2">
                <button type="button" className="btn btn-outline-secondary d-flex align-items-center justify-content-center gap-2">
                  <FcGoogle size={20} /> Continue with Google
                </button>
                <button type="button" className="btn btn-outline-secondary d-flex align-items-center justify-content-center gap-2">
                  <FaApple size={20} /> Continue with Apple
                </button>
              </div>

              <p className="mt-4 text-center text-muted small">
                Don’t have an account?{' '}
                <Link to="/signup" className="fw-bold text-primary text-decoration-none">
                  Sign up
                </Link>
              </p>
            </div>
          </div>

          

        </div>
      </div>
    </div>
  );
}
